module.exports = __webpack_public_path__ + "media/images/countrysquared/pn-02fc2e46d12917822980aeef752e35f2.svg";